import React, { useEffect } from 'react';

import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import { useDispatch, useSelector } from 'react-redux';

import BrokersConnection from 'components/BrokersConnection';

import { ReservationsActions } from 'state/modules/reservations';
import { OrganizationsActions } from 'state/modules/organizations';
import i18n from 'i18n-js';

import useStyles from './Connections.styled';

const ReservationConnections = ({ reservation, showLabel = true }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { fetchingAvailablesBrokers, availablesBrokers, loading } = useSelector(
    (state) => state.organizations
  );

  const addBrokerToReservation = (value) => {
    dispatch(ReservationsActions.fetchAddBroker(reservation?.id, value?.broker));
  };

  const removeBroker = (value) => {
    dispatch(ReservationsActions.fetchRemoveBroker(reservation?.id, value?.broker_slug));
  };

  useEffect(() => {
    dispatch(OrganizationsActions.fetchAvailablesBrokers({ class_slug: 'RB' }));
  }, []); // eslint-disable-line

  return (
    <Box className={classes.container}>
      <Container className="h-100">
        <Grid container direction="row" justifyContent="center" alignItems="center">
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Typography gutterBottom component="div" align="left">
              <Box fontWeight="500" fontSize={14} pr={4} mt={2} mb={4}>
                {showLabel ? i18n.t('vehicle.select_broker') : ''}
              </Box>
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <BrokersConnection
              availables={{
                list: [...availablesBrokers],
                loading: fetchingAvailablesBrokers,
              }}
              loading={loading}
              onAddBroker={addBrokerToReservation}
              onRemoveBroker={removeBroker}
              assigned={reservation?.brokers || {}}
            />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default ReservationConnections;
